export const CurrencySelect_MODULE = {
  state: {
    currency_list: ["KZT", "USD", "RUB", "EUR"],
    selectedCurrency: "KZT",
    currency_signs: {
      KZT: "₸",
      USD: "$",
      RUB: "₽",
      EUR: "€"
    }
  },
  getters: {
    getCurrencySelectList: state => state.currency_list,
    getSelectedCurrency: state => state.selectedCurrency,
    getCurrencySignByTicker: state => ticker => state.currency_signs[ticker],
    getSelectedCurrencySign: (state, getters) => {
      return state.currency_signs[getters.getSelectedCurrency];
    }
  },
  mutations: {
    setSelectedCurrency: (state, payload) => (state.selectedCurrency = payload)
  }
};
